import React, { Fragment, memo } from 'react';
import PropTypes from 'prop-types';
import Dialog from '@mui/material/Dialog';
import { Box, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import Button from '@mui/material/Button';
import { useLangFile } from 'js/context/LanguageContext';
import CircularProgress from '@mui/material/CircularProgress';
import { usePrescriptionJob } from '../PrescriptionJobContext';

const PrescriptionExitSaveDialog = ({
  open,
  savingJob,
  savingError,
  onCancel,
  onExit,
  onSaveAndExit,
  isBulkPrescription,
  bulkPrescriptionFields,
}) => {
  const LangFile = useLangFile();
  const { prescriptionJob } = usePrescriptionJob();
  const isLastField =
    isBulkPrescription &&
    prescriptionJob.fieldId === bulkPrescriptionFields[bulkPrescriptionFields.length - 1].fieldId;
  const disableSaveButton = isBulkPrescription && !isLastField;

  return (
    <Fragment>
      <Dialog open={Boolean(open)} fullWidth maxWidth={'md'}>
        <DialogTitle>
          {savingJob && LangFile.PrescriptionSaveDialog.saving}
          {!savingJob && LangFile.PrescriptionSaveDialog.title}
        </DialogTitle>

        <DialogContent style={{ overflow: 'hidden' }}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            {savingJob ? (
              <CircularProgress size={80} thickness={5} />
            ) : (
              <Fragment>
                {savingError ? (
                  <Box
                    sx={{
                      mb: 1,
                    }}
                  >
                    {LangFile.PrescriptionSaveDialog.error}
                  </Box>
                ) : (
                  <Box
                    sx={{
                      mb: 1,
                    }}
                  >
                    {LangFile.PrescriptionSaveDialog.info}
                  </Box>
                )}
              </Fragment>
            )}
          </Box>
        </DialogContent>
        <DialogActions>
          {!savingJob && (
            <Fragment>
              <Button onClick={onCancel} color="inherit" variant="outlined">
                {LangFile.PrescriptionSaveDialog.cancel}
              </Button>

              {savingError ? (
                <Button onClick={onExit} color="secondary" variant="contained">
                  {LangFile.PrescriptionSaveDialog.onExit}
                </Button>
              ) : (
                <Fragment>
                  <Button onClick={onExit} color="inherit" variant="outlined">
                    {LangFile.PrescriptionSaveDialog.onExit}
                  </Button>
                  <Button
                    onClick={onSaveAndExit}
                    color="primary"
                    variant="contained"
                    disabled={disableSaveButton}
                  >
                    {LangFile.PrescriptionSaveDialog.onSaveAndExit}
                  </Button>
                </Fragment>
              )}
            </Fragment>
          )}
        </DialogActions>
      </Dialog>
    </Fragment>
  );
};

export default memo(PrescriptionExitSaveDialog);

PrescriptionExitSaveDialog.propTypes = {
  open: PropTypes.bool,
  savingJob: PropTypes.bool,
  savingError: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  onExit: PropTypes.func.isRequired,
  onSaveAndExit: PropTypes.func.isRequired,
};
